var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.container},_vm._l((_vm.resources),function(resource){return _c('ShowScheduleVerticalTile',{key:`${resource.id}${resource.scheduled_start_time}`,attrs:{"playlist-item":resource,"artwork":""}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }